// Hand-off URLs: we preview here and navigate in the person's own maps app.
// Google Maps URLs need no API key (developers.google.com/maps/documentation/urls). We only link out;
// no Google content is shown on our map (Maps Platform Terms §3.2.3(e)).

const coord = (n) => Number(n).toFixed(6);

/** mode: 'walk' | 'drive'. app: 'google' | 'apple'. */
export function directionsUrl(app, mode, lat, lon) {
  const dest = `${coord(lat)},${coord(lon)}`;
  if (app === 'apple') {
    return `https://maps.apple.com/?daddr=${dest}&dirflg=${mode === 'drive' ? 'd' : 'w'}`;
  }
  const p = new URLSearchParams({ api: '1', destination: dest, travelmode: mode === 'drive' ? 'driving' : 'walking' });
  return `https://www.google.com/maps/dir/?${p}`;
}

/** Street View panorama link-out. sv = { lat, lon, heading?, pitch? } (falls back to the site point). */
export function streetViewUrl(site) {
  const sv = site.streetview ?? { lat: site.lat, lon: site.lon };
  const p = new URLSearchParams({ api: '1', map_action: 'pano', viewpoint: `${coord(sv.lat)},${coord(sv.lon)}` });
  if (Number.isFinite(sv.heading)) p.set('heading', String(Math.round(sv.heading)));
  if (Number.isFinite(sv.pitch)) p.set('pitch', String(Math.round(sv.pitch)));
  return `https://www.google.com/maps/@?${p}`;
}

/** Best guess for the first-run default; the person still chooses. */
export const suggestedApp = (ua = '') => (/iPhone|iPad|iPod|Macintosh/.test(ua) ? 'apple' : 'google');
